// extracted by mini-css-extract-plugin
export default {"ramp-modal":"CurrencyPurchaseRamp_ramp-modal__Wc925","ramp-modal__content":"CurrencyPurchaseRamp_ramp-modal__content__oMEhV"};